<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ gameName }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_view') }}
            span(slot="value") {{ $i18n.t('couples.couples_view_' + parameters.viewType)  }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}
            span(slot="value") {{ parameters.difficult.amountOfRows + ' x ' + parameters.difficult.amountOfColumns }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_order') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_' + parameters.mode) }}
        game-preview-setting(v-if="parameters.withTime")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_showTime') }}
            span(slot="value") {{ parameters.showTime }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
</template>

<script>
    /*eslint-disable*/
    import GamePreviewSettings from './GamePreviewSettings.vue'
    import GamePreviewSetting from './GamePreviewSetting.vue'
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin'

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting
        },
        computed: {
            gameName () {
                return this.parameters.withTime
                    ? this.$i18n.t('common.common_gameName_matrixWithTime')
                    : this.$i18n.t('common.common_gameName_matrix');
            },
        }
    }

</script>
